import React from 'react';
import {
  columnName, columnLink, columnTarget, columnDescription,
} from '@/constants/fields';
import VocabularyLinksTable from '../containers/VocabularyLinksTable';

const VocabularyCustomLinksTable = () => (
  <VocabularyLinksTable
    columns={[columnName, columnLink, columnDescription, columnTarget]}
    entity="dataset.link"
  />
);

export default VocabularyCustomLinksTable;
